export default __webpack_public_path__ + "static/media/favicon.c0133547.svg";